// extracted by mini-css-extract-plugin
module.exports = {"color-primary":"red","color-graph":"#305c6e","button":"dutch-gp_button_zPDCY","grid":"dutch-gp_grid_2JRHx"};